import { AlkLogger } from '@alk/core';
import { IFeedbackAdapterService } from './feedback-adapter.interface';
import { IFeedbackMessageRequest, IFeedbackMessageResponse } from '../../../interfaces/feedback.interface';
import { injectable } from 'inversify';

const FEEDBACK_MOCK_DELAY = 3000;
const FEEDBACK_HARDCODED_MESSAGE_FOR_ERROR = 'error';

@injectable()
export class FeedbackAdapterMock implements IFeedbackAdapterService {
    sendFeedback(feedbackRequest: IFeedbackMessageRequest): Promise<IFeedbackMessageResponse> {
        AlkLogger.debug('FeedbackAdapterMock#sendFeedback', feedbackRequest);
        return new Promise((resolve) => {
            setTimeout(() => {
                const isError = feedbackRequest.message === FEEDBACK_HARDCODED_MESSAGE_FOR_ERROR;
                const response: IFeedbackMessageResponse =
                    {
                        isAccepted: !isError,
                        reason: isError ? 'Mocked error' : undefined,
                    };

                resolve(response);
            },
            FEEDBACK_MOCK_DELAY,
            );
        });
    }
}
